import { useRef, useState } from 'react';
import jwtDecode from 'jwt-decode';
import { Link, useNavigate } from 'react-router-dom';
import Wrapper from '../global/Wrapper';
import MobileNav from './MobileNav';
import cartIcon from '../../assets/icons/LayoutIcons/cart.svg';
import notificationIcon from '../../assets/icons/LayoutIcons/notification.svg';
import arrowDownIcon from '../../assets/icons/LayoutIcons/arrow-down.svg';
import messageIcon from '../../assets/icons/DashboardIcons/message.svg';
import smilingIcon from '../../assets/icons/DashboardIcons/smiling.svg';
import getInitials from '../../lib/getInitials';
import LogoutCard from '../global/LogoutCard';

type DefaultLayoutHeaderProps = {
  title?: string;
  icon?: string;
};
const DefaultLayoutHeader = ({ title, icon }: DefaultLayoutHeaderProps) => {
  // const location = useLocation();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const ref: any = useRef(null);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const token: any = localStorage.getItem('login-token');

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const details: any = jwtDecode(token);

  const firstName = details.firstName;
  const lastName = details.lastName;

  const fullName = firstName + ' ' + lastName;

  const [showLogout, setShowLogout] = useState(false);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const setLogoutStatefalse = (e: any) => {
    if (ref.current && showLogout && !ref.current.contains(e.target)) {
      setShowLogout(false);
    }
  };
  document.addEventListener('click', setLogoutStatefalse);

  const loginEmail = details.email;

  return (
    <>
      <header className='hidden w-[100%] md:block bg-offDark text-black md:pt-3 pb-8  font-poppins fixed top-0  md:w-[calc(100%-235px)] z-10 '>
        <Wrapper className='mr-[76px] !mt-0 '>
          <div className='sm:!pl-[10px] lg:!pl-[60px]  xl:pr-8 sm:pt-5 '>
            <div className='flex justify-between sm:gap-20 md:gap-20'>
              <div className='flex items-center space-x-2'>
                {!icon && <img src={smilingIcon} alt={smilingIcon} className='w-8' />}

                <h3 className='font-poppins text-green whitespace-nowrap text-xl'>
                  {!title && (
                    <span className='font-semibold text-capitalize '> {`Hello, ${firstName}`}</span>
                  )}
                  {title && (
                    <div className='flex items-center space-x-2'>
                      <img src={icon} alt={icon} className='w-8' />

                      <span className='font-semibold text-capitalize '>{`${title}`}</span>
                    </div>
                  )}
                </h3>
              </div>
              <div className='flex-1 flex items-center justify-end space-x-4'>
                <div className='block w-[24px] cursor-pointer'>
                  <img src={messageIcon} className='w-[24px]' alt='cart-icon' />
                </div>
                <div className='block w-[24px] cursor-pointer'>
                  <img src={cartIcon} className='w-[24px] ' alt='cart-icon' />
                </div>
                <div className='relative w-[14px] block cursor-pointer'>
                  <div className='absolute bg-[#F51010] top-[-1px] right-0 rounded-lg w-[10px] h-[10px]'></div>
                  <img src={notificationIcon} className='w-[14px]' alt='notification' />
                </div>
                <div className='flex items-center gap-1 '>
                  <div className='bg-[#229698] font-poppins flex justify-center items-center text-[10px] text-white  rounded-full w-[22px] h-[22px]'>
                    {getInitials(fullName)}
                  </div>
                  <div>
                    <h3 className='font-poppins font-medium text-green whitespace-nowrap text-capitalize text-[13px]'>
                      {`${fullName}`}
                    </h3>
                    <p className='text-[#768396] text-[8px]'>{`${loginEmail}`}</p>
                  </div>
                </div>
                <div className='relative'>
                  <div className='cursor-pointer'>
                    <img
                      src={arrowDownIcon}
                      ref={ref}
                      className='w-[20px]'
                      alt='arrowDownIcon'
                      onClick={() => setShowLogout((prev) => !prev)}
                    />
                  </div>

                  {showLogout && <LogoutCard />}
                </div>
              </div>
            </div>
          </div>
        </Wrapper>
      </header>
      {/* Mobile Navbar */}
      <div className='block md:hidden'>
        <MobileNav />
      </div>
    </>
  );
};

export default DefaultLayoutHeader;
